import { WorldCountryCode } from '@/config/world-countries-en';

export const enum Languages {
    EN = 'EN',
}

export const enum PlaceTypes {
    ADDRESS = 'address',
}

export type PlaceApiParameters = {
    language: Languages;
    types: PlaceTypes;
    country: WorldCountryCode;
    region: WorldCountryCode;
}


export type Prediction = {
    description: string;
    place_id: string;
    address_components: AddressComponent[];
}

export const enum AddressComponentTypes {
    //FLOOR indicates the floor of a building address
    FLOOR = 'floor',
    //STREET_NUMBER indicates the precise street number
    STREET_NUMBER = 'street_number',
    //STREET_ADDRESS indicates a precise street address
    STREET_ADDRESS = 'street_address',
    //ROUTE indicates a named route (such as "US 101")
    ROUTE = 'route', 
    //LOCALITY indicates an incorporated city or town political entity
    LOCALITY = 'locality',
    //SUBLOCALITY indicates a first-order civil entity below a locality
    SUBLOCALITY = 'sublocality',
    //SUBLOCALITY_LVL_1 indicates a second-order civil entity below a locality
    SUBLOCALITY_LVL_1 = 'sublocality_level_1',
    //COUNTRY indicates the national political entity,
    COUNTRY = 'country', 
    NEIGHBORHOOD = 'neighborhood',
    //ADMINISTRATIVE_AREA_LVL_1 administrative_area_level_1 short names will closely match ISO 3166-2 subdivisions
    // and other widely circulated lists. Within the United States, these administrative levels are states.
    ADMINISTRATIVE_AREA_LVL_1 = 'administrative_area_level_1',
    //ADMINISTRATIVE_AREA_LVL_2 Within the United States, these administrative levels are counties
    ADMINISTRATIVE_AREA_LVL_2 = 'administrative_area_level_2', 
    //POSTAL_CODE indicates a postal code as used to address postal mail within the country.
    POSTAL_CODE = 'postal_code',
    POSTAL_TOWN = 'postal_town'
}

export type AddressComponent = {
    longText: string;
    shortText: string;
    types: AddressComponentTypes[];
}

export type DetailResult = {
    address_components: AddressComponent[];
}








